var v1="<span ng-if=\"!editMode\">{{ score.tee_off_club | teeOfClubLabel }}</span><span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" ng-model=\"score.tee_off_club\" disable=\"!isShotEntered(score)\" options=\"defaultData.teeOffClubOptions\" class=\"input white\"></span></span>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/tee-off-club.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/score-card/templates/tee-off-club.jade
// module id = 406
// module chunks = 0